import React from 'react'
import "./footerstyles.css"

function Footer() {
  return (
    <div className="footer">Footer</div>
  )
}

export default Footer